import React from "react";
import { Link } from "react-router-dom";
import AntModal from "../AntModal";
import { Button } from "../Buttons/Button";
import abbeyImg from "../../assets/studio/abbey-modal.jpg";
import {
  Body,
  NewPill,
  Title,
  Lede,
  LedeStrong,
  Bullets,
  Actions,
  StudioFigure,
  StudioImg,
  StudioCaption
} from "./styles";


/*
 * Shown when a free / logged-out user tries to download a track that's
 * still inside the "New" window. Pitches the subscription with a few
 * benefit bullets and routes to /subscription.
 */
const NewTrackSubscribeModal = ({ modalState, track }) => (
  <AntModal modalState={modalState} width={520}>
    <Body>
      <NewPill>New release</NewPill>
      <Title>
        {track?.title
          ? `"${track.title}" is a subscriber-only release`
          : "This is a subscriber-only release"}
      </Title>
      <Lede>
        Tracks released in the last 6 months are available exclusively to
        Blue Dot Sessions subscribers.
      </Lede>
      <LedeStrong>
        Subscribers have access to all downloads, stems, collaboration tools
        and the multitrack editor.
      </LedeStrong>
      <Bullets>
        <li>Unlimited downloads across the full catalog</li>
        <li>Access to the multitrack editor for every title</li>
        <li>Day-one access to every new release</li>
        <li>Blanket license for podcasts, video, and more</li>
      </Bullets>
      <Actions>
        <Button secondary onClick={modalState.close}>
          Maybe later
        </Button>
        <Link to="/subscription" onClick={modalState.close}>
          <Button subscribe>See subscription plans</Button>
        </Link>
      </Actions>
      <StudioFigure>
        <StudioImg src={abbeyImg} alt="Blue Dot Studios, Turners Falls" />
        <StudioCaption>Blue Dot Studios</StudioCaption>
      </StudioFigure>
    </Body>
  </AntModal>
);

export default NewTrackSubscribeModal;
